import React from 'react';

import { ActionMenuList, ListItem } from '@ds';
import { DSDefaultViewIcon, DSDeleteIcon, DSEditIcon } from '@ds-icons';
import { ModelViewSummary } from '@mpm-druid/types';

import styles from './DashboardViewSelectOption.module.scss';

type DashboardViewSelectOptionProps = {
  data: ModelViewSummary;
  selectedViewId: string | null;
  onClick: () => void;
  onEditView: () => void;
  onSetDefaultView: () => void;
  onDeleteView: () => void;
};

export function DashboardViewSelectOption({
  data,
  selectedViewId,
  onClick,
  onEditView,
  onSetDefaultView,
  onDeleteView
}: DashboardViewSelectOptionProps) {
  const isSelected = selectedViewId === data.id;

  const handleItemClick = () => {
    if (isSelected) return;
    onClick();
  };

  return (
    <div className={styles.optionContainer}>
      <ListItem
        active={isSelected}
        onClick={handleItemClick}
        data-test="dashboard-view-select-option-item"
      >
        <ListItem.Text primary={data.name} />
        <ListItem.ActionContainer>
          {data.is_default ? (
            <ListItem.Action
              className={styles.optionDefaultIcon}
              Icon={<DSDefaultViewIcon />}
              data-test="dashboard-view-select-default-icon"
            />
          ) : null}
          <ActionMenuList className={styles.optionSettingsWrapper}>
            <ActionMenuList.Trigger
              size="small"
              data-test="dashboard-view-select-action-list-trigger"
            />
            <ActionMenuList.Body
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
              }}
              paperClassName={styles.optionSettingsContainer}
            >
              <ListItem
                dataTest="dashboard-view-select-action-list-edit"
                onClick={onEditView}
              >
                <ListItem.PrefixContainer>
                  <ListItem.Icon Icon={<DSEditIcon />} />
                </ListItem.PrefixContainer>
                <ListItem.Text primary="Edit" />
              </ListItem>

              <ListItem
                dataTest="dashboard-view-select-action-list-set-default"
                disabled={data.is_default}
                onClick={onSetDefaultView}
              >
                <ListItem.PrefixContainer>
                  <ListItem.Icon Icon={<DSDefaultViewIcon />} />
                </ListItem.PrefixContainer>
                <ListItem.Text primary="Set as default" />
              </ListItem>

              <ListItem
                dataTest="dashboard-view-select-action-list-delete"
                onClick={onDeleteView}
              >
                <ListItem.PrefixContainer>
                  <ListItem.Icon Icon={<DSDeleteIcon />} />
                </ListItem.PrefixContainer>
                <ListItem.Text primary="Delete" />
              </ListItem>
            </ActionMenuList.Body>
          </ActionMenuList>
        </ListItem.ActionContainer>
      </ListItem>
    </div>
  );
}
